// A single ResizeObserver instance that can be re-used for everything.
const resizeObserver = new ResizeObserver((entries) => {
  for (const entry of entries) {
    const resizeEffect = resizeObserver.map.get(entry.target);
    if (!resizeEffect) {
      console.error(
        "resizeObserver target not mapped, unobserving:",
        entry.target,
      );
      resizeObserver.unobserve(entry.target);
      return;
    }
    resizeEffect(entry);
  }
});
resizeObserver.map = new Map();
const watch = (element, callback) => {
  if (typeof callback !== "function")
    return console.error("second argument must be a callback function");
  if (!(element instanceof Element))
    return console.error("resizeObserver cannot observe", element);
  resizeObserver.map.set(element, callback);
  resizeObserver.observe(element);
};
const unwatch = (element) => {
  resizeObserver.map.delete(element);
  resizeObserver.unobserve(element);
};
const reset = () => {
  resizeObserver.map.clear();
  resizeObserver.disconnect();
};

export default {
  ...resizeObserver,
  observe: watch,
  unobserve: unwatch,
  disconnect: reset,
};
